import { showErrorModal } from "slices/app/actions/error";
import localhost from "apis/localhost";
import { elements } from "constants/types";
import {
  setLoading,
  setDataPrevLength,
  setContentData,
} from "slices/dictionarySearch/dictionarySearchSlice";

export const getContent = (folderId, docList) => async (dispatch, getState) => {
  const by = getState().dictionarySearch.config.folderBy;
  dispatch(setLoading({ element: elements.CONTENT, loading: true }));
  dispatch(setDataPrevLength());

  await localhost
    .post(`/docs/dictionarySearch/${by}/termInstances`, {
      docSetId: folderId,
      docList,
    })
    .then((response) => {
      const { data } = response;
      dispatch(setContentData(data));
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(setLoading({ element: elements.CONTENT, loading: false }));
    });
};
